import { ModalHeader, ModalBody, ModalFooter } from "./elements";
import { Sheets, Theatre, Prompt } from "./variations";
import Modal from "./Modal";
var lib_default = Modal;
export {
  ModalBody,
  ModalFooter,
  ModalHeader,
  Prompt,
  Sheets,
  Theatre,
  lib_default as default
};
